import ThumbnailList from "./ThumbnailList"
import ModalGallery from "./ModalGallery"
import { partImageStyle, thumbnailContainerStyle } from "./styles"
import { useTheme } from "@emotion/react"
import AssetRenderer from "./AssetRenderer"
import { PublishedAsset } from "@ncs/ncs-api/src/portal-apps/point-of-sale/types"

type MultiImagesViewProps = {
	assets: PublishedAsset[]
	onExpand: (asset: PublishedAsset) => void
	onClose: () => void
	selectedAsset: string
	isOpen: boolean
	onAssetClick: (id: string) => void
	isLoading: boolean
	partName: string
}

const MultiImagesView: React.FC<MultiImagesViewProps> = ({
	assets,
	onExpand,
	onClose,
	selectedAsset,
	isOpen,
	onAssetClick,
	isLoading,
	partName,
}) => {
	const theme = useTheme()
	const assetToShow = assets.find((asset) => asset.id.toString() === selectedAsset) ?? assets[0]

	return (
		<section>
			<AssetRenderer
				asset={assetToShow}
				isLoading={isLoading}
				onExpand={onExpand}
				partImageStyle={partImageStyle(theme)}
				spinerMaxWidth={320}
				fetchpriority="high"
			/>

			{assets.length > 1 && (
				<section css={thumbnailContainerStyle}>
					<ThumbnailList
						assets={assets}
						selectedAsset={selectedAsset}
						onThumbnailClick={onAssetClick}
						onExpand={onExpand}
						mode="partial"
					/>
				</section>
			)}

			<ModalGallery
				isOpen={isOpen}
				assets={assets}
				initialAssetToShow={selectedAsset ?? ""}
				onClose={onClose}
				partName={partName}
			/>
		</section>
	)
}

export default MultiImagesView
